import { useState } from "react";

import { useTranslation } from "react-i18next";

import useLeadMutations from "../../../data/useLeadMutations";
import useDefaultCRUDHandlers from "../../../hooks/useDefaultCRUDHandlers";
import { ILead } from "../../../models/Lead";
import Card from "../../shared/Card/Card";

export default function DriverNotes({ lead }: { lead: ILead }) {
  const { t } = useTranslation("leads");
  const { update } = useLeadMutations(lead.id, "DriverNotes");
  const { saveHandlers } = useDefaultCRUDHandlers("Driver Notes");
  const [driverNotes, setDriverNotes] = useState(lead.driverNotes);

  const handleSaveDriverNotes = () => {
    const updatedLead = {
      ...lead,
      driverNotes: driverNotes
    };

    update.mutate(updatedLead, saveHandlers)
  }

  return (
    <Card title={t("Driver Notes")} bodyClassName="p-4">
      <div className="space-y-4">

        <textarea
          className="w-full border-gray-300"
          rows={5}
          defaultValue={lead.driverNotes!}
          onChange={(e) => setDriverNotes(e.target.value)}
          onBlur={() => handleSaveDriverNotes()}
        />

        <button
          className="rounded-md border border-transparent bg-primary-600 px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm hover:bg-primary-700"
          onClick={() => handleSaveDriverNotes()}
        >
          {t("Update")}
        </button>

      </div>
    </Card>
  );
}
